import React, { useEffect } from "react";

// external imports
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/material";

export default function SnackbarComp({
  open,
  onClose,
  errorMessage,
  statusCode,
  autoHideDuration = 5000,
}) {
  const getSeverity = (code) => {
    if (
      code === "0103" ||
      code === "0104" ||
      code === "0105" ||
      code === "0106" ||
      code === "0107"
    ) {
      return "error";
    } else if ((code >= 200 && code < 300) || code === "0302") {
      return "success";
    } else if (
      (code >= 400 && code < 500) ||
      code === "0304" ||
      code === "0308"
    ) {
      return "warning";
    } else if ((code >= 500 && code < 600)) {
      return "error";
    } else {
      return "info";
    }
  };

  const messages = Array.isArray(errorMessage) ? errorMessage : [errorMessage];

  useEffect(() => {
    const handleBlur = () => {
      if (open) onClose();
    };
    window.addEventListener("blur", handleBlur);
    return () => window.removeEventListener("blur", handleBlur);
  }, [open, onClose]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      sx={{ zIndex: 5 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={getSeverity(statusCode)}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {messages.map((message, index) => (
          <Box key={index}>{message}</Box>
        ))}
      </Alert>
    </Snackbar>
  );
}
